export const getLanguages = t => [
  { label: t('english') + ' - English', value: 'en' },
  { label: t('chinese') + ' - 中文', value: 'zh' },
  { label: t('portuguese') + ' - Português', value: 'pt' },
  { label: t('spanish') + ' - Español', value: 'es' },
  { label: t('dutch') + ' - Nederlands', value: 'nl' },
  { label: t('french') + ' - Français', value: 'fr' },
  { label: t('german') + ' - Deutsch', value: 'de' },
  { label: t('russian') + ' - Русский', value: 'ru' },
  { label: t('ukrainian') + ' - Українська', value: 'uk' },
  { label: t('korean') + ' - 한국어', value: 'kr' },
  { label: t('italian') + ' - Italiano', value: 'it' },
  { label: t('czech') + ' - Čeština', value: 'cs' },
];
